import {createStore} from 'redux';
import AppReducer from './reducer';

const AppStore = createStore(AppReducer);

export {AppStore as default}